module.exports = __webpack_public_path__ + "img/w32b.b8210aba.jpg";